import React from 'react';
import {
  Box,
  Grid
} from '@material-ui/core';
import { ObjectiveSelect } from '../../../components/ObjectiveSelect';
import { useFiltrosDashboardPichincha } from '../../../store/useFiltersDashboardPichincha';
import { SelectPeriod } from '../../HeatMap/components/SelectPeriodo';
import { useObjetivosPichincha } from '../hooks/useObjetivosPichincha';

export function Filtros() {  
  const { data: objectivesToDisplay, isLoading: isLoadingObjectiveList } =
    useObjetivosPichincha();
  const objectiveId = useFiltrosDashboardPichincha(
    (state) => state.objetivo?.objetivo_id ?? ''
  );
  const globalStatePeriod = useFiltrosDashboardPichincha(
    (state) => state.globalStatePeriod
  );
  const changeGlobalPeriod = useFiltrosDashboardPichincha(
    (state) => state.changeGlobalPeriod
  );
  const changeObjetivo = useFiltrosDashboardPichincha(
    (state) => state.changeObjetivo
  );

  function handleChangeObjective(selectedObjectiveId) {
    const objetivo = objectivesToDisplay.find(
      (item) => item.objetivo_id === Number(selectedObjectiveId)
    );
    if (!objetivo) {
      console.error('Objetivo no encontrado:', selectedObjectiveId);
      return;
    }
    // Actualizar el estado del objetivo seleccionado
    changeObjetivo(objetivo);
  }  

  return (
    <Box marginTop={2}>
      <Grid container spacing={2} direction="row" justifyContent="flex-end" alignItems="center">
        <Grid item sm={4} md={4} lg={3} xl={3}>
          <SelectPeriod
            changeGlobalPeriodFromParent={changeGlobalPeriod}
            defaultSelectDateRangeFromParent={globalStatePeriod}
          />
        </Grid>
        <Grid item sm={4} md={4} lg={3} xl={3}>
          <ObjectiveSelect
            objetivos={objectivesToDisplay}
            objetivoId={objectiveId}
            setObjetivoId={(id) => handleChangeObjective(id)}
            isLoading={isLoadingObjectiveList}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
